{
  "shared": {
    "filter": {
      "title": "Filters",
      "applied": "Applied:",
      "more": "More filters",
      "show": "Show results",
      "showCount": "Show results: {{count}}",
      "notAvailable": "Not available to you",
      "emptyFilteredHint": "Change or clear the filters to see more.",
      "dateRange": {
        "from": "From",
        "to": "To",
        "toBeforeFrom": "The end date is before the start date."
      }
    }
  }
}
